import React, { useContext, useEffect, useState } from 'react'
import { Box } from '@chakra-ui/react'
import TagManager from 'react-gtm-module'
import CardsLayout from '../components/CardsLayout'
import Header from '../components/Header'
import Tabs from '../components/Tabs'
import { MainContext } from '../context'
import { dictionary } from '../dictionary'
import { useConnection } from '../hooks/useConnection'

// import Banner from '../components/Banner' //SE REMUEVE TEMPORALMENTE EL BANNER

export const Home = ({
  env,
  skin,
  accentColor,
  lang,
  fontFamily,
  gtm,
  setSearchName
}) => {
  const [name, setName] = useState()
  const { pageScrollY, offersData, pagesTotal, currentPage, isLoading } =
    useContext(MainContext)

  const { handlePagination } = useConnection(env, skin)

  const gtmIdHandler = (skin) => {
    switch (skin) {
      case 'COPPEL':
        return {
          dataLayerName: 'CoppelDataLayer'
        }
      case 'CLARA':
        return {
          dataLayerName: 'DataLayer'
        }
      case 'INVEX':
        return {
          dataLayerName: 'DataLayer'
        }
      case 'UNIQ':
          return{
            dataLayerName: 'DataLayer'
          }
      case 'FINSUS':
          return{
            dataLayerName: 'DataLayer'
          }
      case 'LIVERPOOL':
        return {
          dataLayerName: 'DataLayer'
        }
      case 'SUBURBIA':
        return {
          dataLayerName: 'DataLayer'
        }
      default:
        return {}
    }
  }

  const handleFlavorGTM = () => {
    if (gtm === true) {
      TagManager.initialize(gtmIdHandler(skin))
    }
  }

  useEffect(() => {
    handleFlavorGTM()
  }, [])

  useEffect(() => {
    // Volver a la misma altura de la página
    window.scrollTo(0, pageScrollY)
  }, [])

  /// All the banner config is loaded on the next obj, to change the texts please edit below
  // const dataBanner = {
  //   title: `${skin.charAt(0).toUpperCase() + skin.slice(1).toLowerCase()}`,
  //   subTitle: 'Viaja y obtén hasta 50% de cashback',
  //   description: 'Pagando con tu tarjeta de débito o crédito participantes',
  //   buttonText: 'Viajar ahora',
  //   buttonTextColor: '#D02F7B',
  //   background:
  //     'linear-gradient(90deg, rgba(84,49,118,1) 20%, rgba(208,47,123,1) 100%)',
  //   imgUrl: 'https://i.ibb.co/Wn6pKTm/Travel-By-Plane.png',
  //   buttonUrl: 'https://www.reworth.co/'
  // }

  return (
    <Box
      p={
        skin === 'CLARA' ||
        skin === 'INVEX' ||
        skin === 'UNIQ' ||
        skin === 'LIVERPOOL' ||
        skin === 'SUBURBIA'||  
        skin === 'FINSUS'
          ? ['0rem 1rem', '0rem 2rem', '0rem 3rem', '1rem 4rem']
          : ['1rem 1rem', '1rem 2rem', '2rem 3rem', '2rem 4rem']
      }
      bg='brand.bg'
    >
      {skin !== 'CLARA' ? (
        <Header
          dictionary={dictionary[lang]}
          accentColor={accentColor}
          fontFamily={fontFamily}
          skin={skin}
          setName={(name) => setName(name)}
        />
      ) : null}
      {/* <Banner
        title={dataBanner.title}
        subTitle={dataBanner.subTitle}
        description={dataBanner.description}
        buttonText={dataBanner.buttonText}
        buttonTextColor={dataBanner.buttonTextColor}
        background={dataBanner.background}
        imgURL={dataBanner.imgUrl}
        buttonURL={dataBanner.buttonUrl}
        isDesktop={isDesktop}
      /> */}
      <Tabs
        name={name}
        dictionary={dictionary[lang]}
        lang={lang}
        accentColor={accentColor}
        fontFamily={fontFamily}
        env={env}
        skin={skin}
      />
      <CardsLayout
        dictionary={dictionary[lang]}
        accentColor={accentColor}
        fontFamily={fontFamily}
        offersData={offersData}
        isLoading={isLoading}
        pagesTotal={pagesTotal}
        currentPage={currentPage}
        handlePagination={(e) => handlePagination(e)}
        lang={lang}
        skin={skin}
        setSearchName={setSearchName}
      />
    </Box>
  )
}
